import type { Locale } from '@seek/melways-sites';
import gql from 'graphql-tag';

export const getRcommendedGlobalJobTagsFragment = (locale: Locale) => gql`
  fragment RecommendedGlobalJobTagsFragment on RecommendedGlobalJob {
    id
    tags {
      type
      label(locale: "${locale}")
    }
  }
`;

export const getCareerFeedJobBadgesFragment = (
  locale: Locale,
  visitorId: string,
) => gql`
  fragment CareerFeedJobBadgesFragment on CareerFeedJob {
    id
    jobId
    jobBadges(
      locale: "${locale}"
      visitorId: "${visitorId}"
      platform: WEB
      channel: HOME
    ) {
      badgeDetails {
        badge
        displayText
      }
    }
  }
`;
